export enum TristateValues {
  all = 'all',
  yes = 'yes',
  no = 'no'
}
